
/* Page Details */
/**
 * It takes a date in the format DD/MM/YYYY and returns it in the format YYYY-MM-DD
 * @param date - The date to be formatted.
 * @returns A string with the date in the format YYYY-MM-DD
 */
export const formatDate = (date) => {
  const dateArray = date.split('/')

  if (dateArray[1] < 10) {
    dateArray[1] = '0' + dateArray[1]
  }
  if (dateArray[0] < 10) {
    dateArray[0] = '0' + dateArray[0]
  }
  const dateFormatted = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`

  return dateFormatted
}

export const validateCheckboxBrand = (Checked) => {
  if (Checked.includes('7up') || Checked.includes('Coca Cola') || Checked.includes('Pepsi') || Checked.includes('Fanta') || Checked.includes('Sprite') || Checked.includes('Awafrut') || Checked.includes('Levite') || Checked.includes('Mirinda') || Checked.includes('Rockstar') || Checked.includes('Speed') || Checked.includes('7up Free') || Checked.includes('Pepsi Black') || Checked.includes('Pepsi Light') || Checked.includes('Paso de los Toros') || Checked.includes('Paso de los Toros Sin Azúcar') || Checked.includes('H2Oh!') || Checked.includes('Guaraná') || Checked.includes('Gatorade') || Checked.includes('Gatorade NS') || Checked.includes('Red Bull') || Checked.includes('Crush') || Checked.includes('Manaos') || Checked.includes('Levité') || Checked.includes('Powerade') || Checked.includes('Monster')) {
    return true
  }

  return false
}

export const validateCheckboxVolume = (Checked) => {
  if (Checked.includes('1.5 L') || Checked.includes('1.65 L') || Checked.includes('1.75 L') || Checked.includes('1 L') || Checked.includes('2.25 L') || Checked.includes('2.45 L') || Checked.includes('2.5 L') || Checked.includes('250 cc') || Checked.includes('2 L') || Checked.includes('3 L') || Checked.includes('500 cc') || Checked.includes('1.25 L') || Checked.includes('220 ml') || Checked.includes('250 ml') || Checked.includes('269 ml') || Checked.includes('3 L') || Checked.includes('310 ml') || Checked.includes('354 ml') || Checked.includes('355 ml') || Checked.includes('375 ml') || Checked.includes('473 ml') || Checked.includes('500 ml') || Checked.includes('750 ml') || Checked.includes('999 ml')) {
    return true
  }

  return false
}

export const validateCheckboxMaterial = (Checked) => {
  if (Checked.includes('Lata') || Checked.includes('Vidrio') || Checked.includes('PET') || Checked.includes('RECO')) {
    return true
  }

  return false
}

export const validateCheckboxReturnability = (Checked) => {
  if (Checked.includes('Descartable') || Checked.includes('Retornable')) {
    return true
  }

  return false
}
